export default __webpack_public_path__ + "static/worksans-mediumitalic-webfont-c7b144b3f7d35efd4620f23afe5c1f8d.woff";